export enum JourneyBuilderMode {
    CREATE = 'CREATE',
    EDIT = 'EDIT',
    READONLY = 'READONLY',
}
